import { type HttpResponsePayload, createHttpEndpoint } from '../../utils'

/**
 * Given a product id, returns all the data needed to render the accessory exclusions modal
 *
 * TODO Add link to the Spotlight page once available
 * @see {@link https://github.com/BackMarket/api-specs/pull/772}
 */
export const getAccessoryExclusions =
  createHttpEndpoint<GetAccessoryExclusionsResponse>({
    method: 'GET',
    operationId: 'productExcludedAccessoriesFetch',
    path: '/bm/product/:productId/accessory_exclusions',
  })

export type GetAccessoryExclusionsResponse = HttpResponsePayload<{
  title: string
  image: string
  paragraphs: Array<{
    title: string
    icon: string
    text: string
  }>
}>
